document.addEventListener("DOMContentLoaded", (event) => {
    gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

    ScrollSmoother.create({
        wrapper: ".smooth-wrapper",
        content: ".smooth-content",
        smooth: 1.5, // Adjust for more/less smoothness
        ease: "expo",
        effects: true, // Enable parallax and other effects
        smoothTouch: 0.2,
        ignore: "[data-ignore-smooth]",
    });
    // home page top banner
    const bannerTl = gsap.timeline({
    scrollTrigger: {
        trigger: ".home-page-top-banner",
        start: "top 80%",
        toggleActions: "play none none reverse", 
    }
    });

    bannerTl
    .from(".top-banner-title", {
        y: 50,
        opacity: 0,
        duration: 0.8,
        ease: "power3.out"
    })
    .from(".top-banner-subtitle", {
        y: 40,
        opacity: 0,
        duration: 0.8,
        ease: "power3.out"
    }, "-=0.4") 
    
    // Stagger animation for bullet items
    gsap.from(".home-banner-bullet-options .bullet-item", {
    scrollTrigger: {
        trigger: ".home-banner-bullet-options",
        start: "top 90%"
    },
    y: 30,
    opacity: 0,
    duration: 0.6,
    ease: "power2.out",
    stagger: 0.2
    });


    if (window.innerWidth > 576) {
    // Expand center image,. show full width during scroll
    let screenWidth = window.innerWidth;
    let height = screenWidth * 0.41; // 40% of screen height
    gsap.to(".animated-image-item.center", {
        width: `${screenWidth}px`,
        height: `${height}px`,
        ease: "power2.out",
        scrollTrigger: { 
            trigger: ".home-banner-image-section",
            start: "top 20%",
            end: "bottom center",
            scrub: true,
            pin: true,
            pinSpacing: true
        } 
    });
    }
    // expend center image to height 800px in mobile (482px)

    //  if the screen width is less than 482px
    // if (window.innerWidth < 482) {
    //         gsap.to(".animated-image-item.center", {
    //             height: "600px",
    //             // duration: 2.2,
    //             ease: "power2.out",
    //             scrollTrigger: { 
    //             trigger: ".home-banner-image-section",
    //             start: "top 20%",
    //             end: "bottom center",
    //             scrub: true
    //         }
    //     });
    // }



    // client logo section
    gsap.from(".client-logo-section .client-logo-content .client-logo-item", {
        x: -200,
        y: 0,
        opacity: 0,
        duration: 2.5, 
        ease: "power4.out",
        stagger: 0.2,
        scrollTrigger: {
        trigger: ".client-logo-section",
        start: "top 70%",
        toggleActions: "play none none none",
        },
    });
    //  marketing service section
    gsap.from(".bw-marketing-service-section .marketing-service-container .service-intro-content", {
    x: -200,
    y: 0,
    opacity: 0,
    duration: 2.5, 
    ease: "power4.out",
    stagger: 0.2, 
    scrollTrigger: {
        trigger: ".service-intro-content",
        start: "top 70%",
        toggleActions: "play none none none",
    },
    });



    // Accordion  service section

    // Animation for service section on scroll

    gsap.from(".service-item", {
    x: 200,
    opacity: 0,
    duration: 2.5, 
    ease: "power4.out",
    stagger: 0.2, 
    scrollTrigger: {
        trigger: ".service-item",
        start: "top 70%",
        toggleActions: "play none none none",
    },
    }
    )
    gsap.from(".services-accordion-title-text", {
    x: -200,
    opacity: 0,
    duration: 2.5, 
    ease: "power4.out",
    stagger: 0.2, 
    scrollTrigger: {
        trigger: ".services-accordion-title-text",
        start: "top 70%",
        toggleActions: "play none none none",
    },
    })

    // Accordion functionality
    document.querySelectorAll('.service-item').forEach(item => {
    const button = item.querySelector('.service');
    const serviceDetails = item.querySelector('.service-details-dropdown-body');

    gsap.set(serviceDetails, { 
        height: 0, 
        opacity: 0, 
        display: 'none',
        pointerEvents: 'none'
    });
    
    const icon = button.querySelector('.service-icon svg');
    gsap.set(icon, {
        rotation: 0,
        transformOrigin: "center"
    });

    // Hover effect for service items
    button.addEventListener('mouseenter', () => {
        const icon = button.querySelector('.service-icon svg');
        const serviceNumber = button.querySelector('.service-number');
        const serviceTitle = button.querySelector('.service-title');
        
        // Set text colors to white on hover
        icon.style.color = '#ffffff';
        serviceNumber.style.color = '#ffffff';
        serviceTitle.style.color = '#ffffff';
        
        // Only invert icon if button is not active (open)
        if (!button.classList.contains('active')) {
        icon.style.filter = 'brightness(0) invert(1)';
        }
    });

    button.addEventListener('mouseleave', () => {
        const icon = button.querySelector('.service-icon svg');
        const serviceNumber = button.querySelector('.service-number');
        const serviceTitle = button.querySelector('.service-title');
        
        icon.style.filter = 'none';
        icon.style.fill = '#000000';
        icon.style.color = '#000000';
        serviceNumber.style.color = '#929292'; 
        serviceTitle.style.color = '#000000';
    });

    button.addEventListener('click', () => {
        const isOpen = serviceDetails.style.display === 'block';
        const icon = button.querySelector('.service-icon svg');
        
        // Close all other open items
        document.querySelectorAll('.service-item').forEach(otherItem => {
        if (otherItem !== item) {
            const otherButton = otherItem.querySelector('.service');
            const otherDetails = otherItem.querySelector('.service-details-dropdown-body');
            const otherIcon = otherButton.querySelector('.service-icon svg');
            
            if (otherButton.classList.contains('active')) {
            otherButton.classList.remove('active');
            otherDetails.style.pointerEvents = 'none';
            
            gsap.to(otherIcon, {
                rotation: 0,
                transformOrigin: "center",
                duration: 0.4,
                ease: "power2.in"
            });
            
            gsap.to(otherDetails, {
                height: 0,
                opacity: 0,
                duration: 0.6,
                ease: "power2.in",
                onComplete: () => {
                otherDetails.style.display = 'none';
                }
            });
            
            // Reset other icon styles to black when closing
            otherIcon.style.filter = 'none';
            otherIcon.style.fill = '#000000';
            otherIcon.style.color = '#000000';
            const otherNumber = otherButton.querySelector('.service-number');
            const otherTitle = otherButton.querySelector('.service-title');
            otherNumber.style.color = '#000000';
            otherTitle.style.color = '#000000';
            }
        }
        });
        
        if (!isOpen) {
        // Open accordion section
        button.classList.add('active');
        serviceDetails.style.display = 'block';
        serviceDetails.style.pointerEvents = 'auto';
        serviceDetails.style.height = serviceDetails.scrollHeight + 'px';
        serviceDetails.style.opacity = 1;
        icon.style.color = '#ffffff';
        const openTl = gsap.timeline({
            defaults: { ease: "power2.out" }
        });
        openTl.to(icon, {
            rotation: 45,  // Rotate to X position
            transformOrigin: "center",
            duration: 0.6,
            ease: "back.out(1.5)"
        });
        
        openTl.to(serviceDetails, {
            height: serviceDetails.scrollHeight,
            opacity: 1,
            duration: 0.8,
            ease: "sine.out",
            onStart: () => {
            serviceDetails.style.visibility = 'visible';
            },
            onComplete: () => {
            serviceDetails.style.height = 'auto';
            }
        }, "-=0.1");
        } else {
        // Close accordion section
        button.classList.remove('active');
        serviceDetails.classList.remove('active');
        icon.style.filter = 'none';
        icon.style.fill = '#000000';
        icon.style.color = '#000000';
        gsap.to(icon, {
            rotation: 0,
            transformOrigin: "center",
            duration: 0.6,
            ease: "power2.in"
        });
        
        gsap.to(serviceDetails, {
            height: 0,
            opacity: 0,
            duration: 0.6,
            ease: "power2.in",
            onComplete: () => {
            serviceDetails.style.display = 'none';
            serviceDetails.style.pointerEvents = 'none';
            }
        });
        }
    });
    });

    // strategy section title

    gsap.from(".strategy-section .strategy-content-top-title", {
    x: -200,
    y: 0,
    opacity: 0,
    duration: 2.5,
    ease: "power4.out",
    stagger: 0.2,
    scrollTrigger: {
        trigger: ".strategy-section",
        start: "top 50%",
        toggleActions: "play none none none",
    },
    });

    // Strategy Section for cards

    gsap.from(".strategy-section .strategy-section-cards .strategy-card-item", {
    x: -200,
    y: 0,
    opacity: 0,
    duration: 1.8,
    ease: "power4.out",
    stagger: 0.2,
    scrollTrigger: {
        trigger: ".strategy-section",
        start: "top 50%",
        toggleActions: "play none none none",
    },
    });

    // Export Section Image

    gsap.from(".export-section .export-content-image-block", {
    x: -150,
    scale: 0.5,
    rotate: -15,
    duration: 1.5,
    ease: "back.out(1.7)",
    stagger: 0.2,
    scrollTrigger: {
        trigger: ".export-section",
        start: "top 50%",
        toggleActions: "play none none none",
    },
    });

    // Export Section for arrow icon

    gsap.from(".export-content-text-block-image-arrow", {
    x: -200,
    y: 0,
    opacity: 0,
    rotate: -10,
    duration: 1.8,
    ease: "power4.out",
    scrollTrigger: {
        trigger: ".export-content-text-block",
        start: "top 60%",
        toggleActions: "play none none none",
    },
    });

    // Export Section for text
    gsap.from(".export-content-text-block .text-block", {
    x: -200,
    y: 0,
    opacity: 0,
    duration: 2.5,
    ease: "power4.out",
    scrollTrigger: {
        trigger: ".export-content-text-block",
        start: "top 30%",
        toggleActions: "play none none none",
    },
    });

    gsap.from(".export-content-text-block .bullet-list-item", {
    x: -200,
    y: 0,
    opacity: 0,
    duration: 2.5,
    ease: "power4.out",
    stagger: 0.2,
    scrollTrigger: {
        trigger: ".export-content-text-block",
        start: "top 50%",
        toggleActions: "play none none none",
    },
    });
    // secondary button fade in from bottm
    gsap.from(".bw-btn-secondary", {
    y: 200,
    opacity: 0,
    duration: 2.5,
    ease: "power4.out",
    stagger: 0.5,
    scrollTrigger: {
        trigger: ".export-content-text-block",
        start: "top 70%",
        toggleActions: "play none none none",
    },
    onEnter: () => {
        document.body.style.overflow = "hidden";
    },
    onLeave: () => {
        document.body.style.overflow = "auto";
    },
    onEnterBack: () => {
        document.body.style.overflow = "hidden";
    }, 
    });
    // case study section
    gsap.from(".case-study-section .case-study-content-text-block .text-block", {
    x: 200,
    y: 0,
    opacity: 0,
    duration: 2.5,
    ease: "power4.out",
    scrollTrigger: {
        trigger: ".case-study-section",
        start: "top 30%",
        toggleActions: "play none none none",
    },
    onEnter: () => {
        document.body.style.overflow = "hidden";
    },
    onLeave: () => {
        document.body.style.overflow = "auto";
    },
    onEnterBack: () => {
        document.body.style.overflow = "hidden";
    }, 
    });

    // case study section image

    gsap.from(".case-study-section .case-study-content-image-block", {
    x: -150,
    scale: 0.5,
    rotate: 15,
    duration: 1.5,
    ease: "back.out(1.7)",
    stagger: 0.2,
    scrollTrigger: {
        trigger: ".case-study-section",
        start: "top 10%",
        toggleActions: "play none none none"
    }
    });

    //  Scrolling animation on testimonial section
    gsap.from(".testimonial-section .testimonial-title", {
    x: -200,
    y: 0,
    opacity: 0,
    duration: 2.5,
    ease: "power4.out",
    scrollTrigger: {
        trigger: ".testimonial-section",
        start: "top 30%",
        toggleActions: "play none none none",
    },
    });

    // Testimonail slider section
    gsap.from(".testimonial-section .testimonial-slider-item", {
    x: 200,
    opacity: 0,
    duration: 2.5,
    ease: "power4.out",
    stagger: 0.5,
    scrollTrigger: {
        trigger: ".testimonial-section",
        start: "top 70%",
        toggleActions: "play none none none",
    },
    });   
    


    gsap.from(".testimonial-section .slider-section", {
    y: 300,
    opacity: 0,
    duration: 2.5,
    ease: "power4.out",
    stagger: 0.5,
    scrollTrigger: {
        trigger: ".testimonial-section",
        start: "top 70%",
        toggleActions: "play none none none",
    },
    });

    // testimonail slider item
    // drag to scroll
    const sliderTestimonial = document.querySelector('.testimonial-slider-section');
    let isDown = false;
    let startX;
    let scrollLeft;

    sliderTestimonial.addEventListener('mousedown', (e) => {
    isDown = true;
    startX = e.pageX - sliderTestimonial.offsetLeft;
    scrollLeft = sliderTestimonial.scrollLeft;
    sliderTestimonial.style.cursor = 'grabbing';
    });

    sliderTestimonial.addEventListener('mouseleave', () => {
    isDown = false;
    sliderTestimonial.style.cursor = 'grab';
    });

    sliderTestimonial.addEventListener('mouseup', () => {
    isDown = false;
    sliderTestimonial.style.cursor = 'grab';
    });

    sliderTestimonial.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - sliderTestimonial.offsetLeft;
    const walk = (x - startX) * 1.5; 
    sliderTestimonial.scrollLeft = scrollLeft - walk;
    });

    // Form section 
    // Animate the whole form container
    gsap.from(".form-container", {
    x: 100,
    opacity: 0,
    duration: 2,
    ease: "power4.out",
    scrollTrigger: {
        trigger: ".home-page-form-section",
        start: "top 80%",
    }
    });

    // Animate form elements with stagger
    gsap.from(".form-heading, .user-info-input > div, .select-service, .textarea-input, .form-btn", {
    x: 50,
    opacity: 0,
    duration: 1,
    ease: "power2.out",
    stagger: 0.15,
    scrollTrigger: {
        trigger: ".form-container",
        start: "top 70%",
    }
    });

    // Site footer section animation

    gsap.from(".footer-column", {
    scrollTrigger: {
        trigger: ".footer-section",
        start: "top 80%",
    },
    y: 50,
    opacity: 0,
    duration: 0.4,
    ease: "power3.out",
    stagger: 0.2
    }); 

    gsap.from(".collapsible-menu-footer", {
    scrollTrigger: {
        trigger: ".collapsible-menu-footer",
        start: "top 80%",
        toggleActions: "play none none none",
    },
    y: 30,
    opacity: 0,
    duration: 0.4,
    ease: "power3.out",
    delay: 1,
    stagger: 0.2
    });


    document.querySelectorAll(".site-title-text").forEach(title => {
    const text = title.textContent.trim();
    title.innerHTML = text.split("").map(char => `<span class="char">${char}</span>`).join("");
    })

    // ---Site Footer bottom site title animation ---
    gsap.from(".footer-bottom .footer-bottom-site-title .site-title-text .char", {
    y: 200,
    opacity: 0,
    duration: 0.8,
    stagger: 0.05,
    ease: "power4.out",
    scrollTrigger: {
        trigger: ".footer-bottom",
        start: "bottom 100%",
        toggleActions: "play none none none",
    },
    });

});


